<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoCrud
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex>
                  <v-text-field
                    ref="controlFoco"
                    label="Nombre*"
                    v-model="itemActivo.Nombre"
                    :rules="[rules.requerido, rules.maximo50]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <GrillaCrud
      :activo="grillaActivo"
      :columnas="grillaColumnas"
      :itemsDB="grillaItems"
      :loading="loading"
      @ejecutarAccion="grillaEjecutarAccion"
      @editarItem="grillaEditarItem"
      @borrarItem="grillaBorrarItem"
    />
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import EncabezadoCrud from "@/components/EncabezadoCrud";
import PieCrud from "@/components/PieCrud";
import GrillaCrud from "@/components/GrillaCrud";
import Mensaje from "@/components/Mensaje";
export default {
  name: "BancoCrud",
  components: {
    EncabezadoCrud,
    PieCrud,
    GrillaCrud,
    Mensaje
  },
  data() {
    return {
      titulo: "Bancos",
      rutaApi: "Banco/",
      itemVacio: {
        Id_Banco: 0,
        Nombre: ""
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido",
        maximo50: v => (v || "").length <= 50 || "Máximo 50 caracteres"
      },
      grillaColumnas: [{ text: "Nombre", value: "Nombre" }],
      grillaItems: [],
      grillaActivo: false,
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      controlSoloLectura: true,
      accion: ""
    };
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Nuevo":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = false;
          this.$refs.controlFoco.focus();
          break;
        case "Guardar":
          if (this.$refs.form.validate())
            this.mostrarMensaje(true, "ConfirmacionGuardar", null, null);
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "Abrir":
          this.grillaActivo = true;
          this.grillaItems = [];
          break;
        case "Editar":
          this.grillaActivo = false;
          this.controlSoloLectura = false;
          this.$refs.controlFoco.focus();
          break;
        case "Borrar":
          this.grillaActivo = false;
          this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          break;
        case "AceptarConfirmacionBorrar":
          this.borrarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarConfirmacionBorrar":
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = true;
          this.$refs.form.resetValidation();
          break;
      }
    },
    guardarItem(item) {
      this.loading = true;
      HttpHelper.post("Banco", item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    borrarItem(item) {
      this.loading = true;
      HttpHelper.delete("Banco/" + item.Id_Banco)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEjecutarAccion(accion, textoBuscado) {
      switch (accion) {
        case "Listar":
          this.grillaListarItems(textoBuscado);
          break;
        case "Cerrar":
          this.grillaActivo = false;
          break;
      }
    },
    grillaListarItems(textoBuscado) {
      this.loading = true;
      this.grillaItems = [];
      HttpHelper.get(this.rutaApi, {
        palabra: textoBuscado
      })
        .then(response => {
          this.grillaItems = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEditarItem(item) {
      this.loading = true;
      HttpHelper.get(this.rutaApi, {
        id: item.Id_Banco
      })
        .then(response => {
          this.itemActivo = Object.assign({}, response.data);
          this.ejecutarAccion("Editar");
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaBorrarItem(item) {
      this.itemActivo = item;
      this.ejecutarAccion("Borrar");
    },
    mostrarError(error) {
      let detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
